module.exports = __webpack_public_path__ + "img/userLogo.a26d15d2.png";